<template>
  <Calendar
    ref="elementRef"
    :class="this.props.className"
    :style="this.props.style"
    :schedules="model[modelKey]"
    :calendars="this.props.calendars"
    :view="this.props.view"
    :taskView="this.props.taskView"
    :scheduleView="this.props.scheduleView"
    :theme="this.props.theme"
    :week="this.props.week"
    :month="this.props.month"
    :timezones="this.props.timezones"
    :disableDblClick="this.props.disableDblClick"
    :disableClick="this.props.disableClick"
    :isReadOnly="this.props.isReadOnly"
    :template="this.props.template"
    :useCreationPopup="this.props.useCreationPopup"
    :useDetailPopup="this.props.useDetailPopup"
    :usageStatistics="this.props.usageStatistics"
    @afterRenderSchedule="afterRenderScheduleHandle"
    @beforeCreateSchedule="beforeCreateScheduleHandle"
    @beforeDeleteSchedule="beforeDeleteScheduleHandle"
    @beforeUpdateSchedule="beforeUpdateScheduleHandle"
    @clickDayname="clickDaynameHandle"
    @clickSchedule="clickScheduleHandle"
    @clickTimezonesCollapseBtn="clickTimezonesCollapseBtnHandle"
  ></Calendar>
</template>

<script>
import CommonUtil from "../../util/CommonUtil";
import ModelUtil from "../../util/ModelUtil";
import ExpressionUtil from "../../util/ExpressionUtil";
import moment from "moment";

import { Calendar } from "@toast-ui/vue-calendar";
import "tui-calendar/dist/tui-calendar.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";

export default {
  name: "CalendarComponent",
  props: ["elementIndex", "props", "displayData", "detailIndex", "detailModel"],
  components: {
    Calendar: Calendar
  },
  data() {
    return {
      monthOption: {
        daynames: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
        visibleScheduleCount: 1,
        scheduleFilter: this.scheduleFilter
      },
      template: {
        monthGridHeaderExceed: this.monthGridHeaderExceed,
        monthGridHeader: this.monthGridHeader
      },
      calendars: [
        {
          id: "0",
          name: "working day",
          color: "#ffffff",
          bgColor: "#FF4040",
          dragBgColor: "#FF4040",
          borderColor: "#FF4040"
        },
        {
          id: "1",
          name: "weekend",
          color: "#ffffff",
          bgColor: "#BBDC00",
          dragBgColor: "#BBDC00",
          borderColor: "#BBDC00"
        },
        {
          id: "2",
          name: "holiday",
          color: "#ffffff",
          bgColor: "#2E89D0",
          dragBgColor: "#2E89D0",
          borderColor: "#2E89D0"
        },
        {
          id: "3",
          name: "School holiday",
          color: "#ffffff",
          bgColor: "#00A9FF",
          dragBgColor: "#00A9FF",
          borderColor: "#00A9FF"
        },
        {
          id: "90",
          name: "other",
          color: "#666",
          bgColor: "#DEEDFC",
          dragBgColor: "#DEEDFC",
          borderColor: "#DEEDFC"
        },
        {
          id: "91",
          name: "other",
          color: "#666",
          bgColor: "#FFD8D8",
          dragBgColor: "#FFD8D8",
          borderColor: "#FFD8D8"
        }
      ],
      theme: {
        default: {
          "common.holiday.color": "#333",
          "month.holidayExceptThisMonth.color": "rgba(51, 51, 51, 0.4)"
        },
        mini: {
          "month.dayname.height": "15px",
          "month.dayname.textAlign": "center",
          "month.dayname.paddingLeft": "0px",
          "month.dayname.paddingRight": "0px",
          "common.holiday.color": "#333",
          "month.holidayExceptThisMonth.color": "rgba(51, 51, 51, 0.4)",
          "month.schedule.borderRadius": "2px",
          "month.schedule.height": "10px",
          "month.schedule.marginTop": "0px",
          "month.schedule.marginLeft": "2px",
          "month.schedule.marginRight": "2px"
        }
      }
    };
  },
  beforeMount: function() {
    // ClassName
    if (this.props.className == null) this.$set(this.props, "className", null);
    // 样式
    if (this.props.style == null) this.$set(this.props, "style", null);
    // 日历
    if (this.props.calendars == null)
      this.$set(this.props, "calendars", this.calendars);
    // 默认视图
    if (this.props.view == null) this.$set(this.props, "view", "month");
    // 样式
    if (this.props.theme == null) {
      this.$set(this.props, "theme", this.theme.default);
    } else if (typeof this.props.theme == "string") {
      this.$set(this.props, "theme", this.theme[this.props.theme]);
    }
    // 只读
    if (this.props.isReadOnly == null)
      this.$set(this.props, "isReadOnly", true);
    // 模板
    if (this.props.template == null)
      this.$set(this.props, "template", this.template);
    // 月视图属性
    if (this.props.month == null) this.$set(this.props, "month", {});
    this.$set(
      this.props,
      "month",
      Object.assign(this.monthOption, this.props.month)
    );

    if (this.props.taskView == null) this.$set(this.props, "taskView", true);
    if (this.props.scheduleView == null)
      this.$set(this.props, "scheduleView", true);
    if (this.props.week == null) this.$set(this.props, "week", {});
    if (this.props.timezones == null) this.$set(this.props, "timezones", []);
    if (this.props.disableDblClick == null)
      this.$set(this.props, "disableDblClick", false);
    if (this.props.disableClick == null)
      this.$set(this.props, "disableClick", false);
    if (this.props.useCreationPopup == null)
      this.$set(this.props, "useCreationPopup", false);
    if (this.props.useDetailPopup == null)
      this.$set(this.props, "useDetailPopup", false);
    if (this.props.usageStatistics == null)
      this.$set(this.props, "usageStatistics", true);
  },
  mounted: function() {
    // 保存控件实例
    CommonUtil.saveElementToStore(this);
    this.$refs.elementRef.invoke("today");
  },
  computed: {
    model: function() {
      if (this.detailModel) {
        return this.detailModel;
      }
      return ModelUtil.getModelObject(this, this.displayData);
    },
    modelKey: function() {
      if (this.detailModel) {
        return this.displayData;
      }
      return ModelUtil.getModelKey(this, this.displayData, []);
    }
  },
  methods: {
    refresh: function() {
      this.$refs.elementRef.invoke("render", true);
    },
    monthGridHeaderExceed: function(hiddenSchedules) {
      return '<span class="weekday-grid-more-schedules ivu-icon ivu-icon-md-add"></span>';
    },
    monthGridHeader: function(model) {
      var date = parseInt(model.date.split("-")[2], 10);
      var classNames = [];
      classNames.push("tui-full-calendar-weekday-grid-date");
      if (model.isToday) {
        classNames.push("tui-full-calendar-weekday-grid-date-decorator");
      }
      var isHoliday = false;
      this.model[this.modelKey].forEach(e => {
        if (moment(e.start).format("YYYY-MM-DD") == model.date) {
          if (e.calendarId != "0" && e.calendarId < 90) {
            isHoliday = true;
            return false;
          }
        }
      });
      if (isHoliday) {
        if (model.isOtherMonth) {
          classNames.push("holidayExceptThisMonth");
        } else {
          classNames.push("holiday");
        }
      }
      return '<span class="' + classNames.join(" ") + '">' + date + "</span>";
    },
    afterRenderScheduleHandle: function() {
      if (this.props.onAfterRenderSchedule) {
        ExpressionUtil.eval(
          this,
          this.props.onAfterRenderSchedule,
          this.detailModel
        );
      }
    },
    beforeCreateScheduleHandle: function(event) {
      if (this.props.onBeforeCreateSchedule) {
        ExpressionUtil.eval(
          this,
          this.props.onBeforeCreateSchedule,
          this.detailModel,
          event
        );
      }
    },
    beforeDeleteScheduleHandle: function(event) {
      if (this.props.onBeforeDeleteSchedule) {
        ExpressionUtil.eval(
          this,
          this.props.onBeforeDeleteSchedule,
          this.detailModel,
          event
        );
      }
    },
    beforeUpdateScheduleHandle: function(event) {
      if (this.props.onBeforeUpdateSchedule) {
        ExpressionUtil.eval(
          this,
          this.props.onBeforeUpdateSchedule,
          this.detailModel,
          event
        );
      }
    },
    clickScheduleHandle: function(event) {
      if (this.props.onClickSchedule) {
        ExpressionUtil.eval(
          this,
          this.props.onClickSchedule,
          this.detailModel,
          event
        );
      }
    },
    clickDaynameHandle: function() {
      if (this.props.onClickDayname) {
        ExpressionUtil.eval(this, this.props.onClickDayname, this.detailModel);
      }
    },
    clickTimezonesCollapseBtnHandle: function() {
      if (this.props.onClickTimezonesCollapseBtn) {
        ExpressionUtil.eval(
          this,
          this.props.onClickTimezonesCollapseBtn,
          this.detailModel
        );
      }
    },
    scheduleFilter: function(schedule) {
      if (schedule.title) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.mini-calendar /deep/ .tui-full-calendar-month {
  height: 175px;
  min-height: 175px;
}

.mini-calendar /deep/ div,
.mini-calendar /deep/ span {
  line-height: 0;
}

.mini-calendar
  /deep/
  .tui-full-calendar-weekday-grid-line
  .tui-full-calendar-weekday-grid-date {
  height: auto;
  line-height: 0;
  text-align: right;
  padding: 4px 5px;
  width: 100%;
  font-size: 8px;
}

.mini-calendar /deep/ .tui-full-calendar-today {
  background-color: #eee !important;
}

.mini-calendar
  /deep/
  .tui-full-calendar-today
  .tui-full-calendar-weekday-grid-date-decorator {
  height: auto;
  line-height: 0;
  text-align: right;
  padding: 4px 5px;
  background-color: transparent;
  width: 100%;
  color: #333;
  font-weight: bolder;
  font-size: 8px;
}

.mini-calendar /deep/ .tui-full-calendar-weekday-schedule {
  border: 0px;
  height: 12px !important;
}

.mini-calendar /deep/ .tui-full-calendar-weekday-schedule-title {
  text-align: center;
  padding: 0px;
  padding-top: 1px;
  font-size: 10px;
  height: 11px;
  line-height: 11px;
  font-weight: normal;
}

.mini-calendar /deep/ .weekday-grid-more-schedules {
  position: absolute;
  top: 4px;
  left: 5px;
}

/deep/ .holiday {
  color: #ff4040 !important;
}

/deep/ .holidayExceptThisMonth {
  color: rgba(255, 64, 64, 0.4);
}

/deep/ .tui-full-calendar-layout {
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
}
</style>


// WEBPACK FOOTER //
// src/components/base/CalendarComponent.vue